<template>
  <section class="section first_page">
    <div class="container-flud ">
      <loading-block v-if="is_load==false" :loading="!is_load"/>
      <div class="col-md-12 center-block  d-flex justify-content-center loading_div " v-if="is_load==false">
        <h2>Идет загрузка...</h2>
      </div>
      <div   v-if="is_load">
        <common-user-page :user="user" />


        <div class="container mobile_div  pt-2 pb-2">
          <div class=" mt-2 mb-4  col-12">
            <h2 class="text-center">Награды</h2>



          </div>
          <div class="col-12" v-if="rewards.length==0">
            <p>награды не найдены!</p>
          </div>
          <div class="row second_section d-flex justify-content-center mt-2 mb-4  col-12" v-if="rewards.length>0">

            <div class="col-6 col-sm-6 col-lg-2 col-md-3 item_card_container padding_left_right_5   "  v-for="(item,item_index) in rewards" :key="item_index" >
              <div class="item_card_mini">
                <div class="item_data">
                  <div class="shop-item-image reward_image">
                    <router-link class="" :to="{name: 'reward_one', params: {id:item.id }}" tag="a" >
                      <v-lazy-image  :src="item.image"  alt="..."/>

                    </router-link>
                  </div>


                  <div class="shop-item-title d-flex justify-content-center"> <router-link class=" " :to="{name: 'reward_one', params: {id:item.id }}" tag="a" > {{ item.title}}</router-link></div>





                </div>
              </div>

            </div>

          </div>
          <div class="notify_card card col-lg-12 mt-4 section_gray_bg  " v-if="total>offset">
            <div class="row second_section d-flex justify-content-center">
              <button class="btn" @click="startLoading()">Загрузить еще</button>

            </div>
          </div>
        </div>






      </div>
    </div>
  </section>
</template>

<script>
import Api from "@/models/Api";
import LoadingBlock from "@/components/Custom/LoadingBlock";
import Vue from "vue";
import CommonUserPage from "@/components/user_page/CommonUserPage";
import VLazyImage from "v-lazy-image/v2";

export default {
  name: "UserPageReviews",
  data(){
    return {
      "is_load":false,
      'user':null,
      'image_url':null,
      "rewards":[],
      'limit':24,
      'offset':0,
      'total':0,
      'percent':0,
    };
  },
  components: {LoadingBlock,CommonUserPage,VLazyImage},
  mounted: function () {
    var app=this;
    var id=this.$route.params.user_id;
    app.is_load=false;
    app.image_url = Vue.config.IMAGE_URL;
    app.loadMainData(id);

  },
  methods:{
    loadMainData(id){
      var app=this;
      Api.loadUserPageMain(id,function(data){
        app.user=data.user;
        if(app.user.isrewards==true){
          app.startLoading();
        }

      },function(error){

        if(error.response.data.code==404){
          app.$router.push({name:'404'});
        }
      });
    },
    startLoading(){
      var app=this;
      Api.loadUserPageRewards(this.user.last_id,this.limit,this.offset,function(data){
        app.rewards=app.rewards.concat(data.rows);
        app.offset=data.offset;
        app.total=data.total;

        app.is_privacy_rewards=data.is_privacy_rewards;
        app.is_load=true;

      })
    }
  }

}
</script>

<style scoped>

</style>